import Certificate from '@/models/Certificate'
import User, { hasRole, Role } from '@/models/User'

export default class CertificatePolicy {
	viewAny(user: User): boolean {
		return hasRole(user, Role.USER)
	}

	view(user: User, certificate: Certificate): boolean {
		if (hasRole(user, Role.USER)) {
			return user.company?.id === certificate.company.id
		}

		return false
	}

	create(user: User): boolean {
		return hasRole(user, Role.USER)
	}

	update(user: User, certificate: Certificate): boolean {
		if (hasRole(user, Role.USER)) {
			return user.company?.id === certificate.company.id
		}

		return false
	}

	delete(user: User, certificate: Certificate): boolean {
		if (hasRole(user, Role.USER)) {
			return user.company?.id === certificate.company.id
		}

		return false
	}

	restore(user: User, certificate: Certificate): boolean {
		if (hasRole(user, Role.USER)) {
			return user.company?.id === certificate.company.id
		}

		return false
	}

	forceDelete(_user: User, _certificate: Certificate): boolean {
		return false
	}

	approve(_user: User, _certificate: Certificate): boolean {
		return false
	}
}
